import { ChangeEvent, useState } from "react";
import { Eye, EyeClosed } from "@phosphor-icons/react";

interface PasswordInputProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

function PasswordInput({
  value,
  onChange,
  placeholder = "Sua senha",
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md
                  text-gray-400 bg-beige 
                  focus:outline-none focus:border-orange-100 focus:ring-1 focus:ring-orange-200
                  placeholder:font-normal
                  placeholder-gray-200 placeholder:italic"
        placeholder={placeholder}
        required
      />
      <button
        type="button"
        className="absolute inset-y-0 right-0 pr-3 flex items-center"
        onMouseDown={() => setShowPassword(true)}
        onMouseUp={() => setShowPassword(false)}
        onMouseLeave={() => setShowPassword(false)}
      >
        {showPassword ? (
          <Eye className="h-5 w-5 text-gray-400" />
        ) : (
          <EyeClosed className="h-5 w-5 text-gray-400" />
        )}
      </button>
    </div>
  );
}

export default PasswordInput;
